import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { HeaderModule } from 'src/app/_component/header/header.module';

import { AdministratorPageRoutingModule } from './administrator-routing.module';
import { AdministratorPage } from './administrator.page';
import { GuestReportViewModule } from './guest-report/guest-report.module';
import { SharedDirectivesModule } from 'src/app/_directives/shared-directives.module';
import { SubmissionsReportModule } from './submissions-report/submissions-report.module';
import { LoadingStiModule } from 'src/app/_component/loading-sti/loading-sti.module';
import { ParkingReportModule } from './parking-report/parking-report.module';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HeaderModule,
    AdministratorPageRoutingModule,
    GuestReportViewModule,
    SharedDirectivesModule,
    SubmissionsReportModule,
    LoadingStiModule,
    ParkingReportModule
  ],
  declarations: [AdministratorPage]
})
export class AdministratorPageModule {}
